module.exports = __webpack_public_path__ + "static/media/NATO.0ade7442.svg";